import React from "react";
import Belge1 from "../img/certificates/AVEN_KIMYEVI_ISO_22000_2025.jpg";
import Belge2 from "../img/certificates/AVEN_ISO_9001_2025.jpg";
import Belge3 from "../img/certificates/AVEN_GMP_2025.jpg";
import YemİşletmeOnayBelgesi from "../img/certificates/YemİşletmeOnayBelgesi.JPG";
import LanguageApi from "../components/Language";
const Certificates = () => {
  const { certificate, certificate_text } = LanguageApi();
  return (
    <div className="corporate">
      
      <div className="certificates-img-area">
        <div className="certificate-single">
            <>
            <img
                src={YemİşletmeOnayBelgesi}
                className="cert-horizantal"
                alt="certificate"
              />
              <div className="cert-center">
                <img
                  src={Belge1}
                  className="cert-vertical"
                  alt="certificate"
                />
                <img
                  src={Belge2}
                  className="cert-vertical"
                  alt="certificate"
                />
                <img
                  src={Belge3}
                  className="cert-vertical"
                  alt="certificate"
                />
              </div>
            </>

        </div>
      </div>
      <div className="corporate-head">
        <div className="corporate-head-in">
          <h1>{certificate}</h1>
        </div>
      </div>
      <div className="corporate-body">
        <div className="corporate-body-in">
          <p>{certificate_text}</p>
        </div>
      </div>
    </div>
  );
};

export default Certificates;
